import * as mutationType from "../mutation_types";
import moment from "moment";

const state = {
  list: [],
  drawer: false
};

const getters = {
  list: state => state.list || [],
  drawer: state => state.drawer
};

const actions = {
  getInsights({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/insights`)
        .then(res => {
          commit(mutationType.SET_INSIGHTS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  setDrawer({ commit }, val) {
    return new Promise(resolve => {
      commit(mutationType.SET_INSIGHTS_DRAWER, val);
      resolve();
    });
  },
  markInsightRead({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/insights/${id}/read`)
        .then(() => {
          commit(mutationType.MARK_INSIGHT_READ, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteInsight({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`/api/insights/${id}`)
        .then(() => {
          commit(mutationType.DELETE_INSIGHT, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [mutationType.SET_INSIGHTS](state, list) {
    state.list = list;
  },
  [mutationType.SET_INSIGHTS_DRAWER](state, drawer) {
    state.drawer = drawer;
  },
  [mutationType.MARK_INSIGHT_READ](state, id) {
    let index = state.list.findIndex(x => x.id == id);
    if (index >= 0) {
      this._vm.$set(state.list[index], "readDate", moment());
    }
  },
  [mutationType.DELETE_INSIGHT](state, id) {
    let index = state.list.findIndex(x => x.id == id);
    if (index >= 0) {
      state.list.splice(index, 1);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
